import type { ComponentProps } from 'react';
import { QuietErrorBoundary } from '@gonfalon/error-boundaries/QuietErrorBoundary';
import { LinkButton } from '@launchpad-ui/components';
import { Icon } from '@launchpad-ui/icons';
import { type PressEvent } from '@react-types/shared';

import { trackSandboxCalloutClicked, type TrackSandboxCalloutClickedProps } from './analytics';
import { SANDBOX_CTA_TEXT } from './constants';
import { getSandboxUrl } from './getSandboxUrl';

type SandboxLinkButtonProps = Omit<ComponentProps<typeof LinkButton>, 'href'> &
  TrackSandboxCalloutClickedProps & {
    pathname?: string;
    showIcon?: boolean;
    openInNewTab?: boolean;
  };

function SandboxLinkButtonInner({
  source,
  pathname,
  showIcon = false,
  openInNewTab = false,
  ...props
}: SandboxLinkButtonProps) {
  return (
    <LinkButton
      {...props}
      href={getSandboxUrl(pathname)}
      {...(openInNewTab && { target: '_blank', rel: 'noopener noreferrer' })}
      onPress={(event: PressEvent) => {
        props.onPress?.(event);
        trackSandboxCalloutClicked({ source });
      }}
    >
      {showIcon && <Icon name="sandbox" />}
      {SANDBOX_CTA_TEXT}
    </LinkButton>
  );
}

export function SandboxLinkButton(props: SandboxLinkButtonProps) {
  return (
    <QuietErrorBoundary severity="low">
      <SandboxLinkButtonInner {...props} />
    </QuietErrorBoundary>
  );
}
